import { render, staticRenderFns } from "./PermissaoAgenda.vue?vue&type=template&id=724168e0&scoped=true"
import script from "./PermissaoAgenda.vue?vue&type=script&lang=ts"
export * from "./PermissaoAgenda.vue?vue&type=script&lang=ts"
import style0 from "./PermissaoAgenda.vue?vue&type=style&index=0&id=724168e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724168e0",
  null
  
)

export default component.exports